import React, { useEffect, useMemo, useRef, useState } from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { connect } from 'react-redux';
import { Context } from '@leverege/plugin';
import { DashboardContextConsumer } from '@leverege/ui-dashboard';
import { DateTimeRangePicker } from '@leverege/ui-elements';
import { ItemDelegate } from '@leverege/molten-core';
import { jsx as _jsx } from "react/jsx-runtime";
const withContext = Wrapped => function (props) {
  return /*#__PURE__*/_jsx(DashboardContextConsumer, {
    children: value => /*#__PURE__*/_jsx(Wrapped, {
      ...props,
      dashboardContext: value
    })
  });
};
export default {
  create(opts, type) {
    function StatsRenderer(props) {
      const {
        delegate,
        target,
        where: pWhere,
        originalAttribute,
        renderer,
        data,
        queryName,
        range,
        valueStyle,
        object,
        context,
        rendererOpts
      } = props;
      const timer = useRef();
      const [render, setRender] = useState(false);
      useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
      }, []);
      const where = useMemo(() => {
        if (pWhere) {
          return delegate.historyDelegate.convertToFilter(pWhere, {
            ...props,
            objectType: `${originalAttribute.objectType}.history`
          });
        }
        return undefined;
      }, [pWhere]);
      const loadData = () => {
        if (!range) {
          return;
        }
        const r = DateTimeRangePicker.getRange(range);
        const itemDelegate = delegate instanceof ItemDelegate ? delegate : delegate.item(target.id);
        GlobalState.dispatch(itemDelegate.history({
          query: {
            ...r,
            paths: [[originalAttribute.source.field.replace('data/', ''), 'value', {
              type: opts.type,
              function: opts.function
            }]],
            where: where || undefined
          },
          queryName
        }));
        clearTimeout(timer.current);
        timer.current = setTimeout(loadData, 30000);
        setRender(!render);
      };
      useEffect(() => {
        loadData();
      }, [range, where]);
      return type === 'table' ? renderer.renderCell(data) : renderer.getValueComponent(data, valueStyle, object, context, rendererOpts);
    }
    return withContext(connect((state, props) => {
      const {
        context,
        data,
        attribute,
        dashboardContext,
        range: pRange
      } = props;
      const {
        clientProps,
        renderer
      } = context;
      const {
        delegate
      } = clientProps;
      const target = Context.getTarget(context);
      const queryName = `${target.id}.${attribute.name}`;
      const value = attribute.get(target);
      const range = pRange || dashboardContext?.options?.dateTimeRange;
      const where = dashboardContext?.options?.condition;
      return {
        delegate,
        target,
        renderer,
        where,
        data: type === 'table' ? {
          ...data,
          value
        } : renderer.formatAndI18nResolveValue(value, renderer.detail.formatter) || [],
        queryName,
        range
      };
    })(StatsRenderer));
  }
};